import React, { useRef, useState } from "react";
import Img from "./basic/Img";
import Carousel from "./Carousel";
import SearchControl from "./SearchControl";
import useNewsScroll from "./hooks/useNewsScroll";

let scrollFlag = true;

const CarouselItem = ({ item, ...props }) => {
    const showProgram = (item) => {
        props.setdata(item);
        const modal = document.getElementById("modal-wrap");
        modal.style.setProperty("display", "flex");
        document
            .getElementById("timetable")
            .style.setProperty("display", "none");
        document
            .getElementById("modal-contents")
            .style.setProperty("display", "block");
        document.getElementById("modal-contents-left").scrollTop = 0;
        document
            .getElementById("modal-main")
            .style.setProperty("overflow", "hidden");
        document
            .getElementById("modal-main")
            .style.setProperty("box-shadow", "none");
        document.body.style.overflowY = "hidden";
        document
            .getElementById("modal-main-bg")
            .style.setProperty("background", "black");
        document
            .getElementById("modal-main-bg")
            .style.setProperty("opacity", "0.5");
    };
    return (
        <div
            className={`${item.id} contents_carousel-item carousel-item ${
                !item.day.length || !item.category.length ? "void" : ""
            }`}
        >
            {item.hasUrgentTag && (
                <Img
                    fileName="c_urgent_tag"
                    alt="緊急出演！"
                    className="urgent_tag"
                />
            )}
            <Img fileName={item.thumbnailLink} alt={item.thumbnailAlt} />
            <div className="contents_carousel-item_link">
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => {
                        showProgram(item);
                        gtag("event", "click", {
                            event_category: "contents",
                            event_label: `contents${item.idx}`,
                        });
                    }}
                >
                    <Img
                        fileName="c_view_button"
                        className="contents_carousel-item_link_button"
                    />
                </a>

                {item.chargeMovieLink ? (
                    <a
                        href={item.chargeMovieLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => {
                            gtag("event", "click", {
                                event_category: "contents",
                                event_label: `contents${item.idx}_full`,
                            });
                        }}
                    >
                        <Img
                            fileName={item.chargeMovieBuuton}
                            className="contents_carousel-item_link_button "
                        />
                    </a>
                ) : (
                    ""
                )}
            </div>
        </div>
    );
};

const ProgramLinkButtons = ({ program }) => {
    return (
        <div className="contents_carousel-link">
            <div className="contents_carousel-link-content">
                <a
                    href={program.movieLink}
                    className="contents_carousel-link-content_normal"
                >
                    <div className="contents_carousel-link-content_normal"></div>
                </a>
                {item.chargeMovieLink ? (
                    <a
                        href={item.chargeMovieLink}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Img
                            fileName={item.chargeMovieBuuton}
                            className="contents_carousel-item_link_button "
                        />
                    </a>
                ) : (
                    ""
                )}
            </div>
        </div>
    );
};

// 検索タグと検索結果のカルーセルをセットにするコンポーネント
export default function SearchContent({ data, setdata }) {
    const [objects, setObjects] = useState({
        programList: data,
        checkedCategoryList: [],
        checkedDayList: [],
    });
    const [arrowBorder, setArrowBorder] = useState(null);
    const { isNewsActive } = useNewsScroll(arrowBorder);
    let arrowActiveBorder;
    const elm = useRef(null);
    const setArrowActiveBorder = () => {
        const pickupEleRect = elm.current.getBoundingClientRect();

        arrowActiveBorder =
            pickupEleRect.bottom + window.scrollY - window.innerHeight;
        setArrowBorder(arrowActiveBorder);
    };
    const style = () => {
        if (!scrollFlag) {
            return "arrow-active";
        } else if (isNewsActive && scrollFlag) {
            scrollFlag = false;
            return "arrow-active";
        } else {
            return "arrow-inactive";
        }
    };
    const updateIFrameByProgramList = (programList, idx = 0) => {
        const keyNumbers = Object.keys(programList);
        setdata(programList[keyNumbers[idx]]);
    };
    const settings = {
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        beforeChange: (_, next) => {
            updateIFrameByProgramList(objects.programList, next);
        },
    };
    const carouselItems = Object.keys(objects.programList).map((plKey) => (
        <CarouselItem
            item={objects.programList[plKey]}
            key={plKey}
            setdata={setdata}
        />
    ));

    // 番組を選択されたタグから検索する関数
    const getProgramsByCheckedElement = (
        type,
        programSet,
        checkedElementList
    ) => {
        const searchedKeys = Object.keys(programSet).filter((pgKey) => {
            return programSet[pgKey][type].some((pgc) =>
                checkedElementList.includes(pgc)
            );
        });
        const newProgramSet = searchedKeys.map((sKey) => {
            return programSet[sKey];
        });
        return newProgramSet;
    };
    // カルーセル内で表示する番組を更新する関数
    const updateProgramList = (
        programSet,
        checkedCategoryList,
        checkedDayList
    ) => {
        // チェックされたカテゴリの番組リスト、カテゴリにチェック入ってなかったら用意されてるリスト
        let newProgramList =
            checkedCategoryList.length > 0
                ? getProgramsByCheckedElement(
                      "category",
                      programSet,
                      checkedCategoryList
                  )
                : programSet;
        if (checkedDayList.length > 0)
            // 日付にチェックされてたらさらにカテゴリのリストと合わせて条件に合う番組を探す
            newProgramList = getProgramsByCheckedElement(
                "day",
                newProgramList,
                checkedDayList
            );
        if (
            (checkedCategoryList.length !== 0 || checkedDayList.length !== 0) &&
            newProgramList.length === 0
        ) {
            newProgramList = [
                {
                    day: [],
                    category: [],
                    programName: "",
                    channelId: "",
                    channelIcon: "",
                    performer1: {
                        name: "",
                        job: "",
                        info: "",
                    },
                    abstract: "",
                    movieLink: "",
                    thumbnailLink: "",
                    thumbnailAlt: "",
                    titleStyleOption: "",
                    scheStyleOption: "",
                },
            ];
        }
        setObjects({
            ...objects,
            programList: newProgramList,
            checkedCategoryList: checkedCategoryList,
            checkedDayList: checkedDayList,
        });
        updateIFrameByProgramList(newProgramList);
    };

    return (
        <div className="contents">
            <SearchControl
                data={data}
                checkedCategoryList={objects.checkedCategoryList}
                checkedDayList={objects.checkedDayList}
                onCheck={updateProgramList}
            />
            <div className="contents_text">
                <Img fileName="contents_text" />
            </div>
            <div
                className="contents_carousel-wrap"
                ref={elm}
                onLoad={setArrowActiveBorder}
            >
                <Carousel
                    settings={settings}
                    itemList={carouselItems}
                    parrentClass="contents"
                    isArrowActiveClass={style()}
                    dataList={objects.programList}
                />
            </div>
            <p className="annotation">※一部事前収録の配信もございます。</p>
            <p className="annotation">
                ※内容は変更になることもありますので予めご了承ください。
            </p>
            <p className="annotation">
                ※一部ご視聴に会員登録が必要なコンテンツもございます。
            </p>
        </div>
    );
}
